export default "__VITE_ASSET__9EhHL_0R__"